Flup.init(function (flup) {
    const sidebarToggler = $(".navbar__sidebar-toggler")

    sidebarToggler.click(function(e){
        $("#sidebar").toggleClass("active")
    })
})